module.exports = __webpack_public_path__ + "media/images/new/mobile/icons/facebook-ed942912c6bd1570a7d750b5d8a27527.png";